const LEGACY_CONNECT_SECURE_STORAGE_KEYS = [
  'e8_tracker_config_connect_secure',
  'e8_tracker_config_connect_secure_status',
  'e8_tracker_config_encryption_key'
];

let cleanupComplete = false;

export const retireLegacyConnectSecureStorage = () => {
  if (cleanupComplete || typeof window === 'undefined') {
    return;
  }

  const storage = window.localStorage;
  LEGACY_CONNECT_SECURE_STORAGE_KEYS.forEach((key) => storage.removeItem(key));
  cleanupComplete = true;
};
